var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20svh",
    height: "20svh",
    viewBox: "-10 -10 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 7,
    fill: "#007bff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.35,
    cy: 85.35,
    r: 6,
    fill: "#007bff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 100,
    r: 5,
    fill: "#007bff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.65,
    cy: 85.35,
    r: 4,
    fill: "#007bff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 50,
    r: 3,
    fill: "#007bff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.65,
    cy: 14.65,
    r: 2.5,
    fill: "#007bff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 0,
    r: 2,
    fill: "#007bff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.35,
    cy: 14.65,
    r: 1.5,
    fill: "#007bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.bd00f61949211413367a7d03cb7bb21c.svg";
export { ForwardRef as ReactComponent };